import clsx from 'clsx'
import { useRouter } from 'next/router'
import React from 'react'
import { ErrorBoundary } from 'react-error-boundary'

import { historyUtils } from '@wartek-id/fe-toolbox'
import { HeaderBar, HeaderBarLeftAction } from '@wartek-id/header-bar'
import { Icon } from '@wartek-id/icon'

import { shouldHideNav } from 'utils/helper'

import TopicReference from 'app/TopicReferencePage/TopicReference'

import { CustomErrorFallback } from 'components/ErrorBoundary'

import { Layout } from '@/components/Layout'

const TopicReferencePage = () => {
  const router = useRouter()

  return (
    <ErrorBoundary
      resetKeys={[router.asPath]}
      FallbackComponent={({ error, resetErrorBoundary }) => (
        <CustomErrorFallback
          error={error}
          resetErrorBoundary={resetErrorBoundary}
        />
      )}
    >
      {!shouldHideNav() && (
        <HeaderBar fixed borderless className="z-10">
          <HeaderBarLeftAction
            icon={
              <Icon as="i" color="default">
                arrow_back
              </Icon>
            }
            onClick={() => historyUtils.backToApp(router.back)}
          />
        </HeaderBar>
      )}
      <TopicReference />
    </ErrorBoundary>
  )
}

const App = () => {
  return (
    <Layout className={clsx('bg-gray-10', !shouldHideNav() && 'mt-[54px]')}>
      <TopicReferencePage />
    </Layout>
  )
}

export default App
